import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class CatalogueDiamantService {
  create(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/catalogue-diamants`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  update(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/catalogue-diamants/${data?.idCatalogueDia}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  remove(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/catalogue-diamants/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  view(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/catalogue-diamants/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  viewAll() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/catalogue-diamants`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  filterAll(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/catalogue-diamants/filter`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  uploadAffiche(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(
      `${api_url}/catalogue-diamants/upload/affiche/${data?.idCatalogueDia}`,
      data?.file,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  createCDM(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/catalogue-diamants/cdm`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  updateCDM(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/catalogue-diamants/cdm/${data?.idCM}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  removeCDM(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/catalogue-diamants/cdm/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  getPublicList(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/catalogue-diamants/public/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  updateStockTampon(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/catalogue-diamants/stock-tampon`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  listStockTamponConfig() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/catalogue-diamants/stock-tampon`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  listStockTamponAlert() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/catalogue-diamants/stock-tampon/alert`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
}

export default new CatalogueDiamantService();
